import React from 'react';
import * as Render from '../../platformui/Base/Render';
import classNames from 'classnames';
import { hasSelectedRegion, regionHasContent } from './helpers';
import LinkCollectionBlock from '../../blocks/linklist-block';
import useWindowLocationHref from '../../platformui/Hooks/useWindowLocation';

const Blocks = {
  LinkCollectionBlock,
};

const RegionalizedBlocks = (props) => {
  const hrefLocation = useWindowLocationHref();

  const externalCheckRegex = /^http|externa-sidor|lankbibliotek/gi;

  var trackAttributes = {
    'data-event-category': hrefLocation || 'novalue',
    'data-event-action': 'Regionaliserat',
    'data-event-name': '',
  };

  if (props.BlockTypeName === 'LinkCollectionBlock') {
    props.Links.forEach((link) => {
      if (externalCheckRegex.test(link.Href)) {
        const linkAttributes = {
          ...trackAttributes,
          'data-event-name': link.Text,
        };

        link.TrackAttr = linkAttributes;
      }
    });
  }

  if (!hasSelectedRegion(props.currentSelectedRegion, props.SelectedRegions))
    return null;

  return <Render.BlockTypeRenderer {...props} Blocks={Blocks} />;
};

const Content = (props) => {
  return (
    <div className="c-regionalization__content">
      <Render.Block blocks={props.RegionContent} propertyName="RegionContent">
        <RegionalizedBlocks
          currentSelectedRegion={props.currentSelectedRegion}
        />
      </Render.Block>
    </div>
  );
};

const RegionContent = (props) => {
  if (!props.RegionContent) return null;

  const currentSelectedRegion = props.currentRegion
    ? props.currentRegion.Value
    : null;

  const contentClasses = classNames({
    'c-regionalization__contents': true,
    'c-regionalization__contents--hidden':
      typeof regionHasContent(currentSelectedRegion, props.RegionContent) ===
      'undefined',
  });

  return (
    <div
      id={props.Id}
      tabIndex="-1"
      aria-hidden={
        typeof regionHasContent(currentSelectedRegion, props.RegionContent) ===
        'undefined'
      }
      className={contentClasses}
    >
      <Content {...props} currentSelectedRegion={currentSelectedRegion} />
    </div>
  );
};

export default RegionContent;
